import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");

    if (!session_id) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        // Clear the hash so the URL is clean
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user: data } });
      } catch (_e) {
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-start bg-stone-50 px-8">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-md bg-teal-700 flex items-center justify-center">
          <ShieldCheck className="h-5 w-5 text-white animate-pulse" />
        </div>
        <div>
          <div className="font-heading font-semibold text-slate-900">Finishing sign in…</div>
          <div className="text-sm text-slate-500">One moment while we verify your session.</div>
        </div>
      </div>
    </div>
  );
}
